import { useApi } from "./api-provider";
import { ApiError, FetchError } from "./errors";
import { getAuthHeaders, parseErrorResponse } from "./utils";
export const useWidgetsApiClient = () => {
    const { authToken, baseUrl, elevatedAccess, widgetType } = useApi();
    return async ({ url: pathname, method, params, data }) => {
        const url = new URL(baseUrl);
        url.pathname = pathname;
        if (params) {
            const cleanParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => value !== undefined));
            url.search = new URLSearchParams(cleanParams).toString();
        }
        const queryType = method.toLowerCase() === "get" ? "query" : "mutation";
        const headers = {
            ...getAuthHeaders(await Promise.resolve(authToken)),
            ...(elevatedAccess && queryType === "mutation"
                ? { "x-elevated-access-token": elevatedAccess.token }
                : {}),
            "WorkOS-Widgets-Type": widgetType,
            "Content-Type": "application/json",
        };
        const response = await fetch(url, {
            method,
            cache: "no-store",
            headers,
            ...(data ? { body: JSON.stringify(data) } : {}),
        }).catch((error) => {
            throw new FetchError({
                message: `Failed to ${method} ${url.toString()}`,
                queryType,
                context: { error },
            });
        });
        if (!response.ok) {
            const { message, status } = await parseErrorResponse(response);
            throw new ApiError({
                message,
                status,
                queryType: method.toLowerCase() === "get" ? "query" : "mutation",
            });
        }
        return response.json();
    };
};
export const useWidgetsApiQueryOptions = (queryOptions) => {
    const { authTokenQueryKey, baseUrl } = useApi();
    const queryKey = [
        // initial query key needs to go first to allow invalidation of the query name to work
        ...queryOptions.queryKey,
        { authTokenQueryKey, baseUrl },
    ];
    return {
        ...queryOptions,
        queryKey: queryKey,
    };
};
//# sourceMappingURL=widgets-api-client.js.map